(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["installation-manuals"] && !Shopify.designMode) return;
  try {
    
  if (!window.vandossManualDownloadReady) {
    window.vandossManualDownloadReady = true;
    document.addEventListener('click', async (event) => {
      const link = event.target.closest('.manual-download');
      if (!link) return;

      event.preventDefault();
      if (link.getAttribute('aria-busy') === 'true') return;

      const originalLabel = link.textContent;
      link.setAttribute('aria-busy', 'true');
      link.textContent = 'Downloading...';

      try {
        const response = await fetch(link.href, { credentials: 'omit' });
        if (!response.ok) throw new Error(`Download failed: ${response.status}`);

        const file = await response.blob();
        const objectUrl = URL.createObjectURL(file);
        const downloadLink = document.createElement('a');
        downloadLink.href = objectUrl;
        downloadLink.download = link.dataset.filename || 'vandoss-manual.pdf';
        document.body.appendChild(downloadLink);
        downloadLink.click();
        downloadLink.remove();
        window.setTimeout(() => URL.revokeObjectURL(objectUrl), 1000);
      } catch (error) {
        window.open(link.href, '_blank', 'noopener');
      } finally {
        link.removeAttribute('aria-busy');
        link.textContent = originalLabel;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
